import styled from 'styled-components';

export const FormGroupStyled = styled.div`
  display: grid;
  justify-content: flex-start;
  align-items: flex-start;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 64px;
  row-gap: 24px;
  margin-block: 48px;
  width: 100%;
  min-width: 0;
  max-width: 880px;
`;
